import { keyBy } from 'lodash'
import { useUsersStore } from 'src/stores/index.js'

export default {
  getRoleName: state => id => {
    if (state.roles.length > 0) {
      switch (id) {
        case 4:
          return 'Administrador de Organización'
        case 5:
          return 'Administrador de Unidad de Negocio'
        case 401:
          return 'Supervisor de Unidad de Negocio'
        case 8:
          return 'Gestor de Contraseñas'
        case 9:
          return 'Administrador de Usuarios'
        default:
          return state.roles.find(role => role.id === id).name
      }
    }
    return ''
  },
  keyedById (state) {
    return keyBy(state.roles, 'id')
  },
  checkChildren: (state) => (PayNode, uniqueRoles) => {
    // Valida si el nodo tiene hijos, si no, no aplica.
    if (PayNode.children.length === 0) return false

    let nodesArray = []
    // Valida si el nodo es el rol buscado
    if (uniqueRoles.find(role => role.id === PayNode.id)) nodesArray.push(PayNode)

    // Itera los hijos del nodo
    PayNode.children.forEach(node => {
      const children = state.checkChildren(node, uniqueRoles)

      if (children) nodesArray = [...nodesArray, ...children]
    })

    return nodesArray
  },
  returnEachChild: (state) => (currentRole) => {
    // Valida si el nodo tiene hijos, si no, no aplica.
    let nodesArray = []
    if (currentRole.children.length === 0) return [currentRole]

    // Agrega el nodo actual
    nodesArray = [...nodesArray, currentRole]
    // Itera los hijos del nodo
    currentRole.children.forEach(node => {
      const children = state.returnEachChild(node)

      if (children) nodesArray = [...nodesArray, ...children]
    })

    return nodesArray
  },
  getUniqueRolesByHierarchy (state) {
    const usersStore = useUsersStore()
    const uniqueRoles = usersStore.getRolesWithHierarchy.filter((role, index, self) =>
      role.franchise_role_id === role.franchise_id && index === self.findIndex((o) => o.role_id === role.role_id)
    )

    let roles = []
    state.nodes.forEach(node => {
      const nodeFranchiseIds = Array.isArray(node.franchise_role_ids) ? node.franchise_role_ids : []
      const currentFranchiseRoles = uniqueRoles.filter(role => nodeFranchiseIds.includes(role.franchise_role_id))

      if (currentFranchiseRoles.length > 0) {
        const children = state.checkChildren(node, currentFranchiseRoles)

        if (children.length > 0) roles = [...roles, ...children]
      }
    })

    roles.forEach(role => {
      let children = []
      role.children.forEach(child => { children = [...children, ...state.returnEachChild(child)] })
      role.subRoles = children
    })

    return roles
  },
  getAllRoles (state) {
    let roles = []
    state.nodes.forEach(node => {
      let children = []
      node.children.forEach(child => { children = [...children, ...state.returnEachChild(child)] })
      roles = [...roles, node, ...children]
    })

    return roles
  }
}
